export default __webpack_public_path__ + "static/media/twitterclone.dbf2e3f5.png";